export default "__VITE_ASSET__Du59qZnn__"